import React, { useState, useEffect, useContext } from "react";
import { globalInfo } from "../../App";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import dataTableGrid from "../DataTableGrid";
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {
  updateParticipantStatus,
  getParticipantsList,
  deleteData,
  getparticipantdetails,
  submitFormData,
} from "../../Utils/adminFunctions";
import {
  getCountriesDropdown,
  getDoctorStatesDropdowns,
  getRegionDropdown,
  getProfessionDropdown,
  getCategoryDropdown,
  get_Date,
} from "../../Utils/commonFunctions";
let ManageParticipants = () => {
  const { ip_address } = useContext(globalInfo);
  const [listDoctors, setListDoctors] = useState([]);
  //for dropdowns//
  const [listCountries, setListCountries] = useState([]);
  const [listStates, setListStates] = useState([]);
  const [listCategory, setListCategory] = useState([]);
  const [listProfession, setListProfession] = useState([]);
  const [listRegion, setListRegion] = useState([]);
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [address, setAddress] = useState("");
  const [website, setWebsite] = useState("");
  const [category, setCategory] = useState("");
  const [profession, setProfession] = useState("");
  const [region, setRegion] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [source, setSource] = useState("");
  const [sourceRefrrence, setSourceRefrrence] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [qualification, setQualification] = useState("");
  const [participantID, setParticipantID] = useState("");

  const [errorFirstName, setErrorFirstName] = useState("");
  const [errorCategory, setErrorCategory] = useState("");
  const [errorRegion, setErrorRegion] = useState("");
  const [errorCountry, setErrorCountry] = useState("");
  const [errorState, setErrorState] = useState("");
  const [errorSource, setErrorSource] = useState("");
  const [errorProfession, setErrorProfession] = useState("");

  useEffect(() => {
    manage_participants();
    getCategory();
    getRegion();
  }, []);
  const getCategory = async () => {
    const response = await getCategoryDropdown();
    if (response.status == "success") {
      setListCategory(response.optionItems);
    } else {
      setListCategory([]);
    }
  };
  const getRegion = async () => {
    const response = await getRegionDropdown();
    if (response.status == "success") {
      setListRegion(response.optionItems);
    } else {
      setListRegion([]);
    }
  };
  const getCountries = async (region_id) => {
    const reId = region_id ? region_id : "";
    const response = await getCountriesDropdown(reId);
    if (response.status == "success") {
      setListCountries(response.optionItems);
    } else {
      setListCountries([]);
    }
  };
  const getProfession = async (categoryID) => {
    const catId = categoryID ? categoryID : "";
    const response = await getProfessionDropdown(catId);
    if (response.status == "success") {
      setListProfession(response.optionItems);
    } else {
      setListProfession([]);
    }
  };
  const getStates = async (countryID) => {
    const cid = countryID ? countryID : "";
    const response = await getDoctorStatesDropdowns(cid);
    if (response.status == "success") {
      setListStates(response.optionItems);
    } else {
      setListStates([]);
    }
  };
  const manage_participants = async () => {
    const bodyFormData = new FormData();
    const response = await getParticipantsList(bodyFormData);
    if (response.status === "success") {
      setListDoctors(response.data);
      dataTableGrid({
        data_table_id: "#userlist",
        paginate: false,
        scroller: false,
        copy_option: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24,
        ],
        csv_option: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24,
        ],
        print_option: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24,
        ],
        sort_option: [25],
      });
    } else if (response.status === "failure") {
      toast.error(response, { autoClose: 1500 });
    }
  };
  const handleParticipantStatus = async (participantID, participantStatus) => {
    const response = await updateParticipantStatus(
      participantID,
      participantStatus
    );
    if (response.status == "success") {
      manage_participants();
      toast.success(response.message, { autoClose: 1500 });
    } else {
      toast.warning(response.message, { autoClose: 1500 });
    }
  };
  const handledoctorDeleteRecord = async () => {
    let participantID = document.getElementById("deleteParticipant").value;
    const response = await deleteData(participantID, "PARTICIPANT");
    if (response.status == "success") {
      toast.success(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
      manage_participants();
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
    }
  };
  const handlerEditParticipant = async (participant_id) => {
    const response = await getparticipantdetails(participant_id);
    if (response.status == "success") {
      getCountries(response.results.region_id);
      getProfession(response.results.category_id);
      getStates(response.results.country_id);
      setParticipantID(response.results.participant_id);
      setFirstName(response.results.first_name);
      setMiddleName(response.results.middle_name);
      setLastName(response.results.last_name);
      setPhone(response.results.contact);
      setEmail(response.results.email);
      setBusinessEmail(response.results.business_email);
      setAddress(response.results.address);
      setCountry(response.results.country_id);
      setState(response.results.state_id);
      setRegion(response.results.region_id);
      setCategory(response.results.category_id);
      setProfession(response.results.profession_id);
      setCity(response.results.city);
      setWebsite(response.results.website);
      setQualification(response.results.qualification);
      setZipCode(response.results.zip_code);
      setSource(response.results.source);
      setSourceRefrrence(response.results.source_refrrence);
      setHospitalName(response.results.hospital_name);
    } else {
      return false;
    }
  };
  const submitupdatedoctor = async () => {
    let errorRequiredFiled = 0;
    if (firstName === "") {
      setErrorFirstName("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (category === "") {
      setErrorCategory("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (profession === "") {
      setErrorProfession("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (region === "") {
      setErrorRegion("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (country === "") {
      setErrorCountry("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (state === "") {
      setErrorState("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (source === "") {
      setErrorSource("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      return false;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("participant_id", participantID);
    bodyFormData.append("first_name", firstName);
    bodyFormData.append("middle_name", middleName);
    bodyFormData.append("last_name", lastName);
    bodyFormData.append("contact", phone);
    bodyFormData.append("email", email);
    bodyFormData.append("business_email", businessEmail);
    bodyFormData.append("address", address);
    bodyFormData.append("website", website);
    bodyFormData.append("category", category);
    bodyFormData.append("profession", profession);
    bodyFormData.append("region", region);
    bodyFormData.append("country", country);
    bodyFormData.append("state", state);
    bodyFormData.append("city", city);
    bodyFormData.append("zip_code", zipCode);
    bodyFormData.append("source", source);
    bodyFormData.append("source_refrrence", sourceRefrrence);
    bodyFormData.append("hospital_name", hospitalName);
    bodyFormData.append("qualification", qualification);
    bodyFormData.append("entered_by_ip", ip_address);
    const response = await submitFormData(
      "updateparticipantdata",
      bodyFormData
    );
    if (response.status == "success") {
      manage_participants();
      toast.success(response.message, { autoClose: 1500 });
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  return (
    <div>
      <div className="wrapper">
        <input type="hidden" id="deleteParticipant" value=""></input>
        <div className="modal fade show" id="modal-default" arial-modal="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm Deletion</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="close_modal"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this record?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  data-dismiss="modal"
                  className="btn btn-sm btn-dark"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => handledoctorDeleteRecord()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="editPopup"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLongTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">
                  Manage Participants
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="card-body">
                  <form
                    method="post"
                    action="post"
                    encType="multipart/form-data"
                  >
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            First Name<i className="text-danger">*</i>
                          </span>
                          <input
                            type="text"
                            className={
                              "form-control" +
                              (errorFirstName ? " is-invalid" : "")
                            }
                            placeholder="First Name"
                            value={firstName ? firstName : ""}
                            onChange={(e) => {
                              setFirstName(e.target.value);
                              setErrorFirstName("");
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Middle Name
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            value={middleName ? middleName : ""}
                            placeholder="Middle Name"
                            onChange={(e) => {
                              setMiddleName(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Last Name
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last Name"
                            value={lastName ? lastName : ""}
                            onChange={(e) => {
                              setLastName(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Contact No.
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            value={phone ? phone : ""}
                            placeholder="Contact No."
                            onChange={(e) => {
                              setPhone(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Email<i className="text-danger">*</i>
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Email"
                            value={email ? email : ""}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Business Email
                          </span>
                          <input
                            type="text"
                            className={"form-control"}
                            placeholder="Business Email"
                            value={businessEmail ? businessEmail : ""}
                            onChange={(e) => {
                              setBusinessEmail(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Address
                          </span>
                          <textarea
                            className="form-control"
                            value={address ? address : ""}
                            placeholder="Address"
                            onChange={(e) => {
                              setAddress(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Category<i className="text-danger">*</i>
                          </span>
                          <select
                            className={
                              "form-control" +
                              (errorCategory ? " is-invalid" : "")
                            }
                            value={category}
                            onChange={(e) => {
                              getProfession(e.target.value);
                              setCategory(e.target.value);
                              setErrorCategory("");
                            }}
                          >
                            <option value="">Select</option>
                            {listCategory}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Specialization<i className="text-danger">*</i>
                          </span>
                          <select
                            className={
                              "form-control" +
                              (errorProfession ? " is-invalid" : "")
                            }
                            value={profession}
                            onChange={(e) => {
                              setProfession(e.target.value);
                              setErrorProfession("");
                            }}
                          >
                            <option value="">Select</option>
                            {listProfession}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Region<i className="text-danger">*</i>
                          </span>
                          <select
                            className={
                              "form-control" +
                              (errorRegion ? " is-invalid" : "")
                            }
                            value={region}
                            onChange={(e) => {
                              getCountries(e.target.value);
                              setRegion(e.target.value);
                              setErrorRegion("");
                            }}
                          >
                            <option value="">Select</option>
                            {listRegion}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Country<i className="text-danger">*</i>
                          </span>
                          <select
                            className={
                              "form-control" +
                              (errorCountry ? " is-invalid" : "")
                            }
                            value={country}
                            onChange={(e) => {
                              getStates(e.target.value);
                              setCountry(e.target.value);
                              setErrorCountry("");
                            }}
                          >
                            <option value="">Select</option>
                            {listCountries}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            State<i className="text-danger">*</i>
                          </span>
                          <select
                            className={
                              "form-control" + (errorState ? " is-invalid" : "")
                            }
                            value={state}
                            onChange={(e) => {
                              setState(e.target.value);
                              setErrorState("");
                            }}
                          >
                            <option value="">Select</option>
                            {listStates}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Zip/Postal code
                          </span>
                          <input
                            type="text"
                            className={"form-control"}
                            placeholder="Zip/Postal code"
                            value={zipCode ? zipCode : ""}
                            onChange={(e) => {
                              setZipCode(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Qualification
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            value={qualification ? qualification : ""}
                            placeholder="Qualification"
                            onChange={(e) => {
                              setQualification(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Source<i className="text-danger">*</i>
                          </span>
                          <select
                            className={
                              "form-control" +
                              (errorSource ? " is-invalid" : "")
                            }
                            value={source ? source : ""}
                            onChange={(e) => {
                              setSource(e.target.value);
                              setErrorSource("");
                            }}
                          >
                            <option value="">Select</option>
                            <option value="Public">Public</option>
                            <option value="Private">Private</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Source reference
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Source reference"
                            value={sourceRefrrence ? sourceRefrrence : ""}
                            onChange={(e) => {
                              setSourceRefrrence(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span className="custom-label-font-weight">
                            Hospital Name
                          </span>
                          <input
                            type="text"
                            className={"form-control"}
                            placeholder="Hospital Name"
                            value={hospitalName ? hospitalName : ""}
                            onChange={(e) => {
                              setHospitalName(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-sm custom-btn-primary"
                  onClick={submitupdatedoctor}
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>

        <div>
          <ToastContainer></ToastContainer>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="card-title card-header-link custom-link-primary">
                              <b>Manage Participants </b>{" "}
                            </h3>
                          </div>
                          <div className="col-md-4">
                            <h3 className="card-title pull-right "></h3>
                          </div>
                        </div>
                      </div>
                      <div className="card-body scroll-doctos table_scroll">
                        <table
                          id="userlist1"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>S. No.</th>
                              <th>First Name</th>
                              <th>Middle Name</th>
                              <th>Last Name</th>
                              <th>Email</th>
                              <th>Business Email</th>
                              <th>Website</th>
                              <th>Contact no.</th>
                              <th>Region</th>
                              <th>Country</th>
                              <th>State</th>
                              <th>City</th>
                              <th>Address</th>
                              <th>Zip/Postal code</th>
                              <th>Category</th>
                              <th>Specilization</th>
                              <th>Qualification</th>
                              <th>Source</th>
                              <th>Source reference</th>
                              <th>Hospital Name</th>
                              <th>Created by</th>
                              <th>Created date</th>
                              <th>Verified by</th>
                              <th>Verified date</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {listDoctors ? (
                              listDoctors.map((item, i) => (
                                <tr key={++i}>
                                  <td>{++i}</td>
                                  <td>{item.first_name}</td>
                                  <td>{item.middle_name}</td>
                                  <td>{item.last_name}</td>
                                  <td>{item.email}</td>
                                  <td>{item.business_email}</td>
                                  <td>{item.website}</td>
                                  <td>{item.contact}</td>
                                  <td>{item.region_name}</td>
                                  <td>{item.country_name}</td>
                                  <td>{item.state_name}</td>
                                  <td>{item.city}</td>
                                  <td>{item.address}</td>
                                  <td>{item.zip_code}</td>
                                  <td>{item.category_name}</td>
                                  <td>{item.specialization_name}</td>
                                  <td>{item.qualification}</td>
                                  <td>{item.source}</td>
                                  <td>{item.source_refrrence}</td>
                                  <td>{item.hospital_name}</td>
                                  <td>{item.entered_by}</td>
                                  <td>{get_Date(item.created_date)}</td>
                                  <td>{item.varify_by}</td>
                                  <td>{get_Date(item.modified_date)}</td>
                                  <td>
                                    {item.status === 0
                                      ? "In progress"
                                      : item.status === 1
                                      ? "Approved"
                                      : "Rejected"}
                                  </td>
                                  <td>
                                    <div className="action_btn">
                                      {item.status === 0 ||
                                      item.status === 2 ? (
                                        <OverlayTrigger overlay={<Tooltip>Approve</Tooltip>}>
                                        <Button
                                          className="btn btn-sm btn-success"
                                          onClick={() => {
                                            handleParticipantStatus(
                                              item.participant_id,
                                              1
                                            );
                                          }}
                                        >
                                          <i
                                            className="fa fa-check"
                                            aria-hidden="true"
                                          ></i>
                                        </Button>
                                        </OverlayTrigger>
                                      ) : (
                                        <OverlayTrigger overlay={<Tooltip>Reject</Tooltip>}>
                                        <Button
                                          className="btn btn-sm btn-danger"
                                          onClick={() => {
                                            handleParticipantStatus(
                                              item.participant_id,
                                              2
                                            );
                                          }}
                                        >
                                          <i
                                            className="fa fa-ban"
                                            aria-hidden="true"
                                          ></i>
                                        </Button>
                                        </OverlayTrigger>
                                      )}
                                      
                                      <Button
                                        className="btn btn-sm btn-danger"
                                        data-toggle="modal"
                                        data-target="#modal-default"
                                        onClick={() => {
                                          document.getElementById(
                                            "deleteParticipant"
                                          ).value = item.participant_id;
                                        }}
                                      >
                                        <i className="fa fa-trash"></i>
                                      </Button>

                                      
                                      <Button
                                        style={{ pointerEvents: 'hover' }}
                                        className="btn btn-sm custom-btn-primary"
                                        data-toggle="modal"
                                        data-target="#editPopup"
                                        onClick={() => {
                                          handlerEditParticipant(
                                            item.participant_id
                                          );
                                        }}
                                      >
                                        <i className="fa fa-edit"></i>
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={26} className="text-center">
                                  Result not found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default ManageParticipants;
